<template>
  <div>
    <div>
      <v-row v-for="k in fragmapsEnabled" :key="k">
        <v-col cols="7" class="fragmaplabel inline-block">
          <v-checkbox
            v-model="fragmapsAvailable[k].visible"
            :label="fragmapsAvailable[k].name"
            @change="onChange(k)"
            @mouseover.native="help('fragmap', k)"
          />
          <!-- <v-icon
            small
            @mouseover="help('fragmap', k)"
          >
            mdi-information-outline
          </v-icon> -->
        </v-col>
        <v-col cols="5">
          <v-slider
            :step="0.1"
            :max="2.0"
            :min="-2.0"
            :value="fragmapsAvailable[k].cutoff"
            @input="setFragmapCutoff(k, $event)"
          />
        </v-col>
      </v-row>
    </div>
    <div class="surface_group">
      <v-row>
        <v-col>
          <v-checkbox
            v-model="proteinSurfaceChecked"
            label="Protein Surface"
            color="success"
            @change="toggleProteinSurface"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-checkbox
            v-model="exclusionMapChecked"
            label="Exclusion Map"
            color="success"
            @change="toggleExclusionMap"
            @mouseover.native="help('fragmap', 'excl')"
          />
          <!-- <v-icon
          small
          @mouseover="help('fragmap', 'excl')"
        >
          mdi-information-outline
        </v-icon> -->
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  name: "Fragmap",
  computed: {
    ...mapState({
      fragmapsAvailable: (state) => _.cloneDeep(state.fragmaps_available),
      fragmapsEnabled: (state) => _.cloneDeep(state.fragmaps_enabled),
      proteinSurfaceChecked: (state) => _.cloneDeep(state.surface_visible),
      exclusionMapChecked: (state) => _.cloneDeep(state.excl_map_visible),
    }),
  },
  mounted() {
    console.log("fragmapsAvailable ()", this.fragmapsAvailable);
  },
  methods: {
    onChange(maptype) {
      this.$store.dispatch("toggleFragmap", { maptype: maptype });
    },
    setFragmapCutoff(maptype, value) {
      this.$store.dispatch("setFragmapCutoff", {
        maptype: maptype,
        cutoff: value,
      });
    },
    toggleProteinSurface() {
      this.$store.dispatch("toggleProteinSurface");
    },
    toggleExclusionMap() {
      this.$store.dispatch("toggleExclusionMap");
    },
    help(topic, maptype, event) {
      this.$store.dispatch("help", {
        topic: topic,
        maptype: maptype,
      });
    },
  },
};
</script>

<style scoped>
.fragmaplabel {
  line-height: 36px;
}
.surface_group {
  border-top: solid 1px #eee;
  margin-top: 5px;
  padding-top: 5px;
}
.surface_group {
  line-height: 36px;
}
i {
  font-size: 0.9em;
  color: #8492a6;
}
i:hover {
  color: #20a0ff;
  cursor: pointer;
}
</style>
